import React from 'react';
import { useTranslation } from '../i18n/LanguageContext';
import { Language } from '../i18n/index';
import { Globe } from 'lucide-react';

export const LanguageSwitcher: React.FC = () => {
  const { language, setLanguage } = useTranslation();

  const toggleLanguage = () => {
    const newLanguage: Language = language === 'en' ? 'zh' : 'en';
    setLanguage(newLanguage);
  };

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center space-x-2 px-3 py-2 text-sm text-gray-400 hover:text-white rounded-lg transition-colors focus:ring-2 focus:ring-cyan-500 focus:ring-offset-0"
      aria-label={language === 'en' ? 'Switch to Chinese' : 'Switch to English'}
      title={language === 'en' ? 'Switch to Chinese' : 'Switch to English'}
    >
      <Globe className="w-4 h-4" />
      <span className="hidden sm:inline">
        {language === 'en' ? 'EN' : '中文'}
      </span>
    </button>
  );
};
